<template>
  <div>Настройки</div>
</template>

<script>
export default {};
</script>

<style>
</style>